import { BasicDto } from './basicDto';

/** Komt overeen met backend WorkingYearTypeEnum (Assist.Model.Enum). */
export enum WorkingYearType {
  Members = 1,
  Accountancy = 2,
}

export interface WorkingYearBasicDto extends BasicDto<number> {
  StartDate: string | null;
  EndDate: string | null;
  MoreInfo: string;
  FullYear: boolean | null;
}

export interface WorkingYearListDto extends WorkingYearBasicDto {
  IsSelected: boolean;
  OrganizationId: number | null;
  UseForAccountancy: boolean;
  UseForMembers: boolean;
}

export interface WorkingYearDto extends WorkingYearListDto {}

export interface WorkingYearImportDto extends WorkingYearBasicDto {}
